module.exports = __webpack_public_path__ + "img/cloud2.c4928731.png";